import React, { FC, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@sezenta/connection';
import { getLastContractId, isSuperAdmin } from '../context/ContractHelpers';

type Props = {};

export const AuthCheck: FC<Props> = (props) => {
  const [cookies] = useCookies(['refreshToken']);
  const user = useUser();
  const nav = useNavigate();
  useEffect(() => {
    if (!cookies.refreshToken) {
      nav('/login');
      return;
    }
    // CR004: super-admin → admin shell; else fast-path into the last-used contract
    // if known, otherwise the Select-Contract hub (which auto-enters if there's one).
    if (isSuperAdmin(user)) {
      nav('/admin/projects');
    } else {
      const last = getLastContractId();
      nav(last ? `/portal/${last}/dashboard` : '/select-contract');
    }
  }, [cookies.refreshToken, user, nav]);
  return <div></div>;
};
